import { ErrorResponse } from "../../types/error";

export default class BaseDataService {

    protected headers: HeadersInit = { 'Content-Type': 'application/json' };
    protected credentials: RequestCredentials = 'same-origin';
    protected url: string;
    private baseUrl = 'https://app.loanfuel.com/api/v4/public/';

    constructor(url: string) {
        this.url = `${this.baseUrl}${url}`;

        // if (process.env.NODE_ENV === 'development') {
        //     this.credentials = 'include';
        // }
    }

    private async submitRequest(url: string, method: string = 'GET', body: any = null, headers: any = this.headers): Promise<any> {
        let options: any = {
            method: method,
            headers: headers,
            // mode: 'corse',
            credentials: this.credentials,
        }
        if (method !== 'GET') {
            options.body = body;
        }
        const response = await fetch(url, options);
        // if (!this.config.auth.ensureResponsAuth(response)) {
        //     return Promise.reject(new ErrorResponse("Unauthorized", response))
        // }

        if (!response.ok) {
            return Promise.reject(new ErrorResponse(response.statusText, response));
        }
        if (method == "DELETE") {
            return;
        }
        else {
            return response;
        }
    }

    request = (url: string, method: string = 'GET', body: any = null, headers: any = this.headers): Promise<any> => this.submitRequest(url, method, JSON.stringify(body), headers);

    protected async requestJSON(url: string, method: string = 'GET', body: any = null, headers: any = this.headers, noResponse: boolean = false): Promise<any> {
        headers = headers? headers : this.headers
        const res = await this.request(url, method, body, headers);
        if (res) {
            if (noResponse) {
                return res;
            } else {
                return res.json();
            }
        }
    }



}